/* eslint-disable react-hooks/exhaustive-deps */
import { Link, Outlet } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import { FC, useContext, useEffect, useMemo, useState } from 'react';

import './styles.scss';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import Button from 'components/ui/button';
import GaleriaReconhecimento from './components/GaleriaReconhecimento';
import DestaquesCultura from './components/DestaquesCultura';
import Realizacao from './components/Realizacao/Index';
import { AuthContext } from 'context/AuthContext';
import Tippy from '@tippyjs/react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import TabTitle from 'components/tab-title';

// const menu = ['Galeria de Reconhecimento', 'Destaques da Cultura', 'Realizações Destaque'];
const menu = ['Galeria de Reconhecimento', 'Destaques da Cultura'];

interface TitleTabOptions {
  title: JSX.Element;
  hideFilter?: boolean;
  options: any;
  className?: string;
}

export default function Destaque() {
  const { realCycle, user } = useContext(AuthContext);

  const [activeTab, setActiveTab] = useState(user?.extra.rede ? 0 : 0);
  const [hiddenHead, setHiddenHead] = useState(false);
  const [optionsCycle, setOptionsCycle] = useState<any>([]);
  const [activeCycle, setActiveCycle] = useState<any>(null);

  useEffect(() => {
    if (!realCycle) return;
    const cycleOptions = realCycle
      // .filter((item: any) => item.title === '1S2023')
      // .filter((item: any) => item.date_start >= 1675652400000 && item.date_start <= 1690772400000)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  const title = useMemo(() => {
    switch (activeTab) {
      case 0:
        return <>Reconhecimentos recebidos pelos participantes</>;
      case 1:
        return (
          <div className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
            <span>Dimensões do comportamento</span>
          </div>
        );
      // case 2:
      //   return (
      //     <>
      //       <span>Realizações Destaque</span>
      //     </>
      //   );

      default:
        return <></>;
    }
  }, [activeTab]);

  function typeText() {
    return <></>;
    // return (
    //   <p>
    //     Para ser um Destaque em uma das dimensões Colaboração, Inovação, Foco no Cliente, Proatividade ou Liderança
    //     Engajadora e ser premiado com 2.000 (dois mil) pontos, você precisa:
    //     <br /> <br />
    //     Alcançar no mínimo 5 (cinco) reconhecimentos na respectiva dimensão do comportamento;
    //     <br /> <br />
    //     Não estar no nível Iniciante; e Não estar no nível Iniciante;
    //     <br /> <br />
    //     Estar com a pontuação dentre as 5% melhores do seu grupo em uma das Dimensões da Cultura.
    //     <br />
    //     <br />A divulgação dos classificados na dinâmica Destaques da Cultura será realizada por ordem alfabética. Apenas você
    //     pode visualizar sua pontuação.
    //   </p>
    // );
  }

  useEffect(() => {
    if (user?.extra.rede) {
      setActiveTab(1);
    }
  }, [user]);

  return (
    <>
      {menu ? (
        <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
          {!hiddenHead && (
            <>
              <div className=" mb-3 lg:mb-10">
                <div className="md:flex justify-between items-center">
                  <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
                    <div>
                      <Link to="../" tabIndex={-1}>
                        <button
                          className="rounded-full bg-purple flex justify-center items-center p-1"
                          aria-label="Botão: Voltar"
                        >
                          <RiArrowLeftSLine size={28} className="text-white" />
                        </button>
                      </Link>
                    </div>

                    <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full" tabIndex={0}>
                      Destaques
                    </h1>
                  </div>
                </div>

                <div className="mt-10">
                  <TabTitle title={title} options={optionsCycle} key={1} onCallBack={e => setActiveCycle(e)} />
                </div>
              </div>

              {/* <div className="flex justify-between items-center lg:hidden mb-10">
                <Button
                  color="clear"
                  className="shadow-none pr-0 pl-0"
                  disabled={activeTab < 1}
                  onClick={() => setActiveTab(activeTab - 1)}
                >
                  <IoIosArrowBack className={`text-grey-dark ${activeTab === 0 && 'bg-opacity-5'}}`} size={24} />
                </Button>

                <p className="text-xl font-bold text-yellow">{menu[activeTab]}</p>

                <Button
                  color="clear"
                  className="shadow-none pr-0 pl-0"
                  disabled={activeTab > 0}
                  onClick={() => setActiveTab(activeTab + 1)}
                >
                  <IoIosArrowForward className={`text-grey-dark ${activeTab > 0 && 'opacity-5'}}`} size={24} />
                </Button>
              </div> */}

              {/* <div className="rounded-xl overflow-hidden items-center justify-between mb-12 hidden lg:flex">
                {!user?.extra.rede && (
                  <button
                    className={`${
                      activeTab === 0 ? 'bg-slate-blue' : 'bg-maastricht-blue'
                    } w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
                    onClick={() => setActiveTab(0)}
                  >
                    Galeria de Reconhecimento
                  </button>
                )}
                <button
                  className={`${
                    activeTab === 1 ? 'bg-slate-blue' : 'bg-maastricht-blue'
                  } w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
                  onClick={() => setActiveTab(1)}
                >
                  Destaques da Cultura
                </button> */}

              {/* {!user?.extra.rede && (
                  <button
                    className={`${
                      activeTab === 2 ? 'bg-slate-blue' : 'bg-maastricht-blue'
                    } w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
                    onClick={() => setActiveTab(2)}
                  >
                    Realizações Destaque
                  </button>
                )} */}
              {/* </div> */}
            </>
          )}

          <DestaquesCultura showHead={e => setHiddenHead(e)} options={activeCycle} />

          {/* {activeTab === 0 && <GaleriaReconhecimento showHead={e => setHiddenHead(e)} options={activeCycle} />} */}

          {/* {activeTab === 1 && <DestaquesCultura showHead={e => setHiddenHead(e)} options={activeCycle} />} */}

          {/* {activeTab === 2 && <Realizacao showHead={e => setHiddenHead(e)} options={activeCycle} />} */}
        </div>
      ) : null}
      <Outlet />
    </>
  );
}
